<template>

  <div>
    
    <b-card
      class="mt-3"
      header="Configure Form"
    >
      <div
        class="row"
        style="height: calc(100vh - 330px); overflow:auto;"
      >
        <div class="col-6 text-left">
          <!-- <b-form-checkbox
          v-model="$store.state.isDisabledTranslation"
            class="mb-3"
          >Disable Translation</b-form-checkbox>-->
          <b-form-group label="Translation Type">
            <b-form-radio
              v-model="formTranslationType"
              @input="updateTranslationType"
              name="translationtype"
              value="custom"
              >Custom</b-form-radio
            >
            <b-form-radio
              v-model="formTranslationType"
              @input="updateTranslationType"
              name="translationtype"
              value="googletranslate"
              >Google Translate</b-form-radio
            >
          </b-form-group>

          <b-form-group
            label="Form Languages"
            v-if="formTranslationType == 'custom'"
          >
            <b-form-checkbox-group
              @change="updateFormLanguages"
              v-model="formTranslations"
              :options="languages"
              stacked
            ></b-form-checkbox-group>
          </b-form-group>
        </div>
        <div class="col-6 text-left">
          <b-form-checkbox
            v-model="form.isReadOnly"
            value=1
            unchecked-value=0
            class="mb-3"
            >Read only form</b-form-checkbox
          >
          <b-form-group label="Version">
            <b-form-input
              @input="updateFormVersion"
              v-model="formVersion"
              type="text"
            ></b-form-input>
          </b-form-group>
          <b-row>
            <!-- list of forms -->
            <b-col cols="6">
              <b-form-group
                label="Type"
                stacked
              >
                <b-form-radio-group
                  :disabled="isFormPublished"
                  stacked
                  v-model="formType"
                  :options="formTypeOptions"
                  name="form-type"
                  @input="updateFormType"
                ></b-form-radio-group>
              </b-form-group>
            </b-col>
            <!-- for traing with test -->
            <b-row
              no-gutters
              v-if="formType == 11"
            >
              <b-col
                cols="12"
                class="text-left"
              >
                <b-form-group label="Select Slide from where you want to start test">
                  <v-select
                    label="filename"
                    v-model="form.selectedSlideForTest"
                    :options="this.trainingSlides"
                  ></v-select>
                </b-form-group>
              </b-col>

              <!-- selec training test exam to link with training -->
              <b-col
                cols="12"
                class="text-left"
              >
                <b-form-group label="Select practice test for this training">
                  <v-select
                    label="title"
                    v-model="form.practiceExamSelect"
                    :options="$store.state.practiceExams"
                  ></v-select>
                </b-form-group>
              </b-col>
              <b-form-checkbox
                v-model="form.isMandatory"
                class="mb-3"
              >Mandatory Test</b-form-checkbox>
            </b-row>

            <!-- for exams -->
            <b-col cols="6">
              <b-form-checkbox
                v-if="formType == 4"
                v-model="form.formConfiguration.exam.isAllCorrectMandatory"
                class="mb-3"
                >All correct answers must be selected</b-form-checkbox
              >
              
              <b-form-checkbox
                v-if="formType == 4 || formType == 12  "
                v-model="isUnlimitedExam"
                @change="onExamUnlitedClick"
                class="mb-3"
                >Unlimited Attempts</b-form-checkbox
              >

              <b-form-checkbox
                v-if="formType == 4 || formType == 12  "
                v-model="form.formConfiguration.exam.isAllowedEmpty"
                class="mb-3"
                >Allow Blank Answers</b-form-checkbox
              >

              <b-form-group
                v-if="(formType == 4 || formType == 12 ) && !isUnlimitedExam"
                label="Maximum number of attempts"
              >
                <b-form-input
                  size="sm"
                  min="0"
                  @input="updateMaxExamAttempts"
                  v-model="maxExamAttempts"
                  type="number"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                v-if="formType == 4 || formType == 12 "
                label="Exam Time Limit (minutes)"
              >
                <b-form-input
                  size="sm"
                  min="0"
                  @input="updateExamTimeLimit"
                  v-model="examTimeLimit"
                  type="number"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                v-if="formType == 4 || formType == 12 "
                label="Sequential Answers"
              >
                <b-form-checkbox
                  v-model="examSequentialAnswer"
                  value="1"
                  @input="updateSequentialAnswers"
                  >Enable sequential answers</b-form-checkbox
                >
              </b-form-group>
              <b-form-group
                v-if="formType == 4 || formType == 12 "
                label="Randomised Questions"
              >
                <b-form-checkbox
                  v-model="examRandomiseQuestions"
                  value="1"
                  @input="updateExamRandomiseQuestions"
                  >Enable Randomised Questions</b-form-checkbox
                >
              </b-form-group>
              <b-form-group
                v-if="(formType == 4 || formType == 12 ) && examRandomiseQuestions == 1"
                label="Number questions per attempt"
              >
                <b-form-input
                  size="sm"
                  min="0"
                  @input="updateExamUniqueAnswersPerAttempt"
                  v-model="examUniqueAnswersPerAttempt"
                  type="number"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                v-if="formType == 4 || formType == 12 "
                label="Exam pass mark"
              >
                <b-form-input
                  size="sm"
                  min="0"
                  @input="updateExamPassMark"
                  v-model="examPassMark"
                  type="number"
                ></b-form-input>
              </b-form-group>
            </b-col>

            <!-- for traning exams -->
            <b-col
              cols="12"
              class="text-left"
              v-if="(formType == 3 || formType == 11) && this.formExams.length"
            >
              <b-form-group label="Select Exams">
                <v-select
                  label="title"
                  v-model="selectedExamForTraining"
                  :options="this.formExams"
                ></v-select>
                  <!-- @input="onSelectExam" -->
              </b-form-group>
                <b-btn variant="outline-success"
                :disabled="isLoading" 
          @click="onSelectExam" size="sm" class="my-2">
          <b-spinner small v-if="isLoading"></b-spinner>
          Confirm Exam</b-btn>
            </b-col>

            <!-- for tranings signature forms -->
            <b-col
              cols="12"
              class="text-left"
              v-if="formType == 3 && this.formTrainings.length"
            >
              <b-form-group label="Select Sign Of">
                <v-select
                  label="title"
                  v-model="selectedTraining"
                  :options="this.formTrainings"
                ></v-select>
              </b-form-group>
                  <!-- @input="onSelectTraining" -->
            </b-col>
          </b-row>
          <!-- to confirm selected -->
          <b-btn v-if="selectedTraining"  variant="outline-success" 
          :disabled="isLoading" 
          @click="onSelectTraining" size="sm" class="my-2">
          <b-spinner small v-if="isLoading"></b-spinner>
          Confirm</b-btn>

          <!-- check for form intro show -->
            <!-- v-if="formType != 4" -->

          <b-form-checkbox
            v-model="showFormIntro"
            @change="onShowFormClick"
            class="mb-3"
          >Show Form Intro</b-form-checkbox>

          <b-form-group
            label="Layout"
            stacked
            v-if="formType != 4 && formType != 3"
          >
            <b-form-radio-group
              stacked
              v-model="formLayout"
              :options="formLayoutOptions"
              name="form-layout"
              @change="updateFormLayout"
            ></b-form-radio-group>
          </b-form-group>

          <b-form-group
            label="Enumerated Fields"
            v-if="formType != 4 && formType != 3"
          >
            <b-form-checkbox
              @change="updateFormEnumeration"
              v-model="enableSectionFieldEnumeration"
              value="1"
              unchecked-value="0"
              stacked
              >Enable enumerated fields</b-form-checkbox
            >
          </b-form-group>

          <b-form-group label="Password">
            <b-form-checkbox
              @input="updateFormPassword"
              v-model="formRequirePassword"
              value="1"
              unchecked-value="0"
              stacked
            >Enable password access</b-form-checkbox>
          </b-form-group>
          <b-form-group>
            <b-form-checkbox
              v-model="form.enableNotificationModal"
              value="1"
              unchecked-value="0"
              stacked
            >Enable Link Up Notification Modal</b-form-checkbox>
          </b-form-group>
        </div>
      </div>
    </b-card>
    <b-navbar
      toggleable="sm"
      type="dark"
      variant="dark"
    >
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse
        id="nav-collapse"
        is-nav
      >
        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav-form>
            <b-button
              size="sm"
              variant="light"
              class="my-2 my-sm-0"
              type="button"
              to="/form/details"
              >Next</b-button
            >
          </b-nav-form>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>

  <!-- <ul>
      <li>color picker for selecting for required *</li>
      <li>Options to configure form background color or image</li>
  </ul>-->
</template>

<script>
import { mapGetters, mapMutations, mapState } from "vuex";
import { EventBus } from "@/event-bus.js";
import { HTTP } from "../utils/HTTP";
import Cryptr from "cryptr";

export default {
  name: "FormConfigurationContainer",
  components: {},
  data () {
    return {
      // form model
      isLoading:false,
      formTranslationType: "custom",
      formVersion: undefined,
      formTranslations: [],
      formType: null,
      formRequirePassword: 0,
      showFormIntro: false,
      isFormPublished: false,
      formLayout: "vertical",
      trainingSlides: [],
      formTypeOptions: [
        {
          text: "External Questionaire",
          value: 1,
        },
        {
          text: "Survey",
          value: 2,
        },
        {
          text: "Training",
          value: 3,
        },
        {
          text: "Exam",
          value: 4,
        },
        {
          text: "Executive Summary",
          value: 5,
        },
        {
          text: "PDF Uploads",
          value: 6,
        },
        {
          text: "Internal Questionaire",
          value: 7,
        },
        {
          text: "Signature Form",
          value: 8,
        },
        {
          text: "Internal Company Form",
          value: 9,
        },
        {
          text: "Certification Form",
          value: 10,
        },
        { value: 11, text: "Training With Practice Exam" },
        { value: 12, text: "Practice Exam" },
      ],

      formLayoutOptions: [
        {
          text: "Vertical",
          value: "vertical",
        },
        {
          text: "Tabbed",
          value: "tabbed",
        },
      ],

      languages: [
        {
          text: "English",
          value: "English",
          disabled: true,
        },
        {
          text: "Arabic",
          value: "Arabic",
        },
        {
          text: "Chinese Simplified",
          value: "Chinese Simplified",
        },
        {
          text: "Chinese Traditional Taiwan",
          value: "Chinese Traditional Taiwan",
        },
        {
          text: "Czech",
          value: "Czech",
        },
        {
          text: "Dutch",
          value: "Dutch",
        },
        {
          text: "French",
          value: "French",
        },
        {
          text: "German",
          value: "German",
        },
        {
          text: "Greek",
          value: "Greek",
        },
        {
          text: "Gujarati",
          value: "Gujarati",
        },
        {
          text: "Hebrew",
          value: "Hebrew",
        },
        {
          text: "Hindi",
          value: "Hindi",
        },
        {
          text: "Hungarian",
          value: "Hungarian",
        },
        {
          text: "Indonesian",
          value: "Indonesian",
        },
        {
          text: "Italian",
          value: "Italian",
        },
        {
          text: "Japanese",
          value: "Japanese",
        },
        {
          text: "Kannada",
          value: "Kannada",
        },
        {
          text: "Korean",
          value: "Korean",
        },
        {
          text: "Marathi",
          value: "Marathi",
        },
        {
          text: "Polish",
          value: "Polish",
        },
        {
          text: "Portuguese",
          value: "Portuguese",
        },

        {
          text: "Romanian",
          value: "Romanian",
        },
        {
          text: "Russian",
          value: "Russian",
        },

        {
          text: "Spanish",
          value: "Spanish",
        },

        {
          text: "Slovenian",
          value: "Slovenian",
        },
        {
          text: "Swedish",
          value: "Swedish",
        },
        {
          text: "Tamil",
          value: "Tamil",
        },
        {
          text: "Telugu",
          value: "Telugu",
        },
        {
          text: "Thai",
          value: "Thai",
        },
        {
          text: "Turkish",
          value: "Turkish",
        },
        {
          text: "Ukrainian",
          value: "Ukrainian",
        },
        {
          text: "Vietnamese",
          value: "Vietnamese",
        },
      ],
      enableSectionFieldEnumeration: 0,
      maxExamAttempts: 5,
      examTimeLimit: 0,
      examSequentialAnswer: 0,
      examRandomiseQuestions: 0,
      examUniqueAnswersPerAttempt: 0,
      examPassMark: 0,
      isUnlimitedExam: false,

    
      //get exams for training
      practiceExamSelect: null,
      formExams: [],
      formTrainings: [],
      selectedExamForTraining: null,
      selectedTraining: null,
      isDisabledTranslation: false,
    };
  },

  computed: {
    ...mapGetters( {
      // form: "form1",
      selectedLanguage: "selectedLanguage",
    } ),
    ...mapState( {
      form: "form1",
    } ),
  },

  watch: {
    form ( form ) {
      this.updateFormLocals();
    },
  },

  async mounted () {
    // Remove after code release
    await this.getFormStatus();
    await this.updateFormLocals();
  },

  async beforeDestroy () {
    await EventBus.$emit( "onAutoSaveJsonForm", true );
  },

  methods: {
    getFormStatus () {
      const cryptr = new Cryptr( "myTotalySecretKey" );
      const decryptedString = cryptr.decrypt(
        localStorage.getItem( "formStatus" )
      );
      this.isFormPublished = decryptedString == 1 ? true : false;
    },

    async getExamsForTraining () {
      let formId = this.$store.state.form1.formId;
      try {
        let result = await HTTP("post", "api/v1/getclientexams", {
          formId: formId,
        });
        if (result.data && result.data.exams && result.data.exams.length) {
          this.formExams = result.data.exams;
          console.log(this.formExams,"this.formExams")
        }
      } catch (error) {
        // console.log("error----", error);
      }
    },

    getSelectedTraining() {

      if (
        this.$store.state.form1.linkedTraining &&
        this.$store.state.form1.linkedTraining.formId
      ) {
         this.selectedTraining = this.$store.state.form1.linkedTraining
      }
      console.log("getSelectedTraining", this.$store.state.form1.linkedTraining);
    },

    getSelectedExam() {
      this.selectedExamForTraining =
          ( this.form.linkedExam && this.form.linkedExam.title ) || null;
      console.log("getSelectedExam", this.form.linkedExam);
    },

    async getTrainings () {
      let formId = this.$store.state.form1.formId;
      try {
        let result = await HTTP("post", "api/v1/getclienttrainingdata", {
          formId: formId,
        });
        // console.log("rsyle dtaa", result.data.training)
        if (
          result.data &&
          result.data.training &&
          result.data.training.length
        ) {
          this.formTrainings = result.data.training;
        }
      } catch ( error ) {
        console.log( "error----", error );
      }
    },

    

    getSlidesData () {
      console.log( this.form.formSection[0].formElements[0], 'fornssss' )
      if (this.$store.state.form1 && this.$store.state.form1.formSection && this.$store.state.form1.formSection.length && this.$store.state.form1.formSection[0].formElements.length ) {
        this.form.formSection[0].formElements[0].files.filter(
          ( slide, index ) => {
            if ( slide && slide.english ) {
              slide.english = {
                ...slide.english,
                slideIndex: index,
              };
              this.trainingSlides.push( slide.english );
            }
          }
        );
      }
    },

    async setSubTask ( e ,type) {
      // console.log( "settings taskssss",e );
      this.isLoading = true;
      /* 19March2024 */
      // if(localStorage.getItem("activeFormId")){
      let formId = localStorage.getItem("activeFormId");
      /*}else{
       let formId = this.$store.state.form1.formId;
      }*/

      let relatedTaskIds = [];
      relatedTaskIds.push( {
        formId: e.id,
        type: type,
        is_active: 1,
        title: e.title || null,
        onboarding_form_versions_id: e.onboarding_form_version_id
      } );

      // console.log("relatedTaskIds", relatedTaskIds);
      try {
        let result = await HTTP( "post", "api/v1/set/onboardingforms/sub/tasks", {
          relatedTaskIds: relatedTaskIds,
          formId: formId,
        } );
        this.isLoading = false;
        //19March2024
        // update linked Exam 
         if( this.form.linkedExam){
           this.form.linkedExam = relatedTaskIds;
         }

        // console.log("setSubTask setSubTask dtaa", result);
      } catch ( error ) {
        console.log( "error----", error );
        this.isLoading = false;
      }
    },

    updateFormLocals () {
      this.formTranslationType = this.form.formTranslationType
        ? this.form.formTranslationType
        : "custom";
      this.formTranslations = this.form.formTranslations || [];
      this.formVersion = this.form.formVersion;
      this.formType = this.form.formType;
      console.log(this.form.formType,"this.myform")

      this.showFormIntro = this.form.isShowFormIntro || false;
      this.formLayout = this.form.formLayout;

      if ( this.form.formType == 4 || this.form.formType == 12 || this.form.formType == 11) {
        this.maxExamAttempts = parseInt(
          this.form.formConfiguration.exam.examMaxAttempts
        );
        this.examTimeLimit = parseInt(
          this.form.formConfiguration.exam.examTimeLimit
        );
        this.examSequentialAnswer = parseInt(
          this.form.formConfiguration.exam.examSequentialAnswer
        );
        this.examRandomiseQuestions = parseInt(
          this.form.formConfiguration.exam.examRandomiseQuestions
        );
        this.examUniqueAnswersPerAttempt = parseInt(
          this.form.formConfiguration.exam.examUniqueAnswersPerAttempt
        );
        this.examPassMark = parseInt(
          this.form.formConfiguration.exam.examPassMark
        );

        this.isUnlimitedExam =
          this.form.formConfiguration.exam.isUnlimitedAttempts || false;
      }

      this.enableSectionFieldEnumeration = parseInt(
        this.form.enableSectionFieldEnumeration
      );

      if ( this.form.formType == 3 || this.form.formType == 11) {
        console.log('here')
        this.getExamsForTraining();
        this.getTrainings();
        this.getSelectedExam();
      this.getSlidesData();
      this.getSelectedTraining();
      }
      // console.clear();
    },

    updateExamUniqueAnswersPerAttempt () {
      this.form.formConfiguration.exam.examUniqueAnswersPerAttempt = this.examUniqueAnswersPerAttempt;
    },

    onShowFormClick ( e ) {
      this.showFormIntro = e;
      Object.assign( this.form, ( this.form.isShowFormIntro = e ) );
    },

    updateExamPassMark () {
      this.form.formConfiguration.exam.examPassMark = parseInt(
        this.examPassMark
      );
    },

    updateExamRandomiseQuestions () {
      if ( this.examRandomiseQuestions != 1 ) {
        this.form.formConfiguration.exam.examUniqueAnswersPerAttempt = 0;
        this.examUniqueAnswersPerAttempt = 0;
      }
      this.form.formConfiguration.exam.examRandomiseQuestions = parseInt(
        this.examRandomiseQuestions
      );
    },

    updateSequentialAnswers () {
      this.form.formConfiguration.exam.examSequentialAnswer = parseInt(
        this.examSequentialAnswer
      );
    },

    updateMaxExamAttempts () {
      this.form.formConfiguration.exam.examMaxAttempts = parseInt(
        this.maxExamAttempts
      );
    },

    updateExamTimeLimit () {
      this.form.formConfiguration.exam.examTimeLimit = parseInt(
        this.examTimeLimit
      );
    },

    updateFormEnumeration ( e ) {
      // console.log("e", e)
      this.form.enableSectionFieldEnumeration = e;
    },

    updateFormLanguages ( e ) {
      // console.log("aa", e)
      // this.form.formTranslations = [];
      // this.form.formTranslations.push("English");
      this.form.formTranslations = e;
    },

    updateFormType ( e ) {
      // 6 ---> PDF
       if (this.formType && typeof this.form == "object") {
        this.form.formType = this.formType;
        if (this.form.formId && this.formType == 3) {
          this.getExamsForTraining();
          this.getTrainings();
        }
      }
    },

    updateFormLayout ( e ) {
      this.form.formLayout = e;
    },

    updateFormPassword () {
      this.form.formRequirePassword = this.formRequirePassword;
    },

    updateTranslationType () {
      this.form.formTranslationType = this.formTranslationType;
    },

    updateFormVersion () {
      this.form.formVersion = this.formVersion;
    },

    // for training exmas
    onSelectExam ( e ) {
      console.log(this.selectedExamForTraining,"this.selectedExamForTraining")
      // this.selectedExamForTraining = e.title;
      if(this.selectedExamForTraining && this.selectedExamForTraining.id){
        this.setSubTask( this.selectedExamForTraining ,4);
      /*let linkedExam = {
        id: this.selectedExamForTraining.id || null,
        formId: this.form.formId,
        company_id: this.selectedExamForTraining.company_id || null,
        title: this.selectedExamForTraining.title || null,
        createdBy: this.selectedExamForTraining.created_by_id || null,
      };
      Object.assign( this.form, { linkedExam } );*/
      }
    
    },

    onSelectTraining ( e ) {
      // console.log("onSelectTraining", this.selectedTraining);
      if(this.selectedTraining && this.selectedTraining.id){
        this.setSubTask( this.selectedTraining,8 );
        /*let linkedTraining = {
        id: this.selectedTraining.id || null,
        formId: this.form.formId,
        company_id: this.selectedTraining.company_id || null,
        title: this.selectedTraining.title || null,
        createdBy: this.selectedTraining.created_by_id || null,
        // shcema: e.schema || null
      };
      Object.assign( this.form, { linkedTraining } );*/
      }
    },

    // for unlimited attemts exam
    onExamUnlitedClick ( e ) {
      if ( e ) {
        this.maxExamAttempts = 0;
      } else {
        this.maxExamAttempts = 5;
      }
      this.updateMaxExamAttempts();
      Object.assign( this.form.formConfiguration.exam, {
        isUnlimitedAttempts: e,
      } );
    },

    onDisabledTranslation ( e ) {
      // console.log("onDisabledTranslation", e)
      Object.assign( this.form.formConfiguration, {
        isDisabledTranslation: e,
      } );
    },
  },
};
</script>
